import React from 'react';


export const Mobx = props => {
    return (
        <img className={props.className} src={require('../../../resources/images/png_icons/mobx.png')} />
    )
};
